import Forecast from 'components/forecast'
import { appliesMeta } from '@/utils/functions/applies-meta'

export default appliesMeta({
    requiresAuth: true,
    can: 'read financials',
    template: 'chameleon'
  },
  [
    {
      path: '/forecast',
      component: Forecast.Index,
      name: 'forecast.index',
    }
  ])
